import Vue from "vue";

import App from "./App.vue";
import VeeValidate, {
  Validator
} from "vee-validate";
import VueLoading from "vue-loading-template";
import * as VueGoogleMaps from "vue2-google-maps";
import VueI18n from 'vue-i18n';
import {
  VueReCaptcha
} from 'vue-recaptcha-v3'
import "./plugins/vueI18n";

import store from "./store/index";

export const i18n = new VueI18n({
  locale: 'en',
});


// For more options see below
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTH_KEY_PROD,
})
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDEq14pmXC9vYy_NEGDeBj8z256b_9c1vs"
  }
});

window.url_api = process.env.VUE_APP_API_URL;

/* Validador ---> */
const configValidador = {
  errorBagName: "errors_validate", // change if property conflicts
  fieldsBagName: "fields",
  locale: "es"
};
import es from "vee-validate/dist/locale/es";
Validator.localize("es", es);

// Import and use Vue Froala lib.
Vue.use(VeeValidate, configValidador);

Vue.use(VueLoading /** options **/ );

window.vueApp = new Vue({
  i18n,
  render: h => h(App),
  store
}).$mount("#app");